var React = require('react');

function Inactive (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#333","strokeLinecap":"round","strokeLinejoin":"round","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"9","cy":"9","r":"9","fill":"#FFF","key":0}),React.createElement("path",{"fill":"#DDD","d":"M14.034 16.25L4.107 1.794l9.927 14.456z","key":1})]));
}

Inactive.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Inactive;

Inactive.default = Inactive;
